var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_763_4728",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_763_4728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.25 14.75C6.8375 14.75 6.48438 14.6031 6.19063 14.3094C5.89688 14.0156 5.75 13.6625 5.75 13.25V5.75C5.75 5.3375 5.89688 4.98438 6.19063 4.69063C6.48438 4.39688 6.8375 4.25 7.25 4.25H17.75C18.1625 4.25 18.5156 4.39688 18.8094 4.69063C19.1031 4.98438 19.25 5.3375 19.25 5.75V13.25C19.25 13.6625 19.1031 14.0156 18.8094 14.3094C18.5156 14.6031 18.1625 14.75 17.75 14.75H7.25ZM12.5 11.225L7.25 7.56875V13.25H17.75V7.56875L12.5 11.225ZM12.5 9.3875L17.75 5.75H7.25L12.5 9.3875ZM4.25 17.75C3.8375 17.75 3.48438 17.6031 3.19063 17.3094C2.89688 17.0156 2.75 16.6625 2.75 16.25V6.875H4.25V16.25H16.625V17.75H4.25Z",
    fill: "#535969"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSvg);
export default __webpack_public_path__ + "static/media/messageSvg.044dfe40bb615bbb2484857716475f7b.svg";
export { ForwardRef as ReactComponent };